export default __webpack_public_path__ + "static/media/vignetteFeastMarly.ca15d001.jpg";